export type SocialPlatform = 'x' | 'discord'

export const SOCIAL_BIND_KEYS: Record<SocialPlatform, string> = {
  x: 'XOpenID',
  discord: 'DiscordOpenID',
}

/** platform param for GET /user/follow_task */
export const FOLLOW_TASK_PLATFORM: Partial<Record<SocialPlatform, number>> = {
  x: 1,
}

/** Dev mock only; real value comes from GET /user/follow_task rewardAmount */
export const SOCIAL_MEDIA_MOCK_CREDIT_REWARD = 20

/** Enable when backend provides disconnect endpoint */
export const SOCIAL_MEDIA_DISCONNECT_ENABLED = false

/** Enable when Discord bind/follow APIs are ready */
export const SOCIAL_MEDIA_DISCORD_ENABLED = false

export type SocialBindStatus = {
  platform: SocialPlatform
  linked: boolean
  /** Display name when linked; backend may not provide OAuth username yet */
  accountName?: string
  /** Seed for boring-avatars; defaults to accountName or platform */
  avatarSeed?: string
  creditEarned?: number
}

export type FollowTaskInfo = {
  bound: boolean
  followed: boolean
  /** Reward in cents; 100 = 1 credit */
  rewardAmountCent?: number
}
